import React, { forwardRef } from 'react'
import { css, cx } from '@linaria/core'
import { colors } from '../theme'

export const skeletonCss = css`
  width: 100%;
  background: ${colors.transparent.gray03};
  // Allow Skeletons to animate even with reduced motion settings so user knows content is loading
  animation: pulse 0.6s infinite alternate ease-in-out !important;
  will-change: background;

  @keyframes pulse {
    to {
      background: ${colors.transparent.gray10};
    }
  }
`

const Base = ({ as: TagName = 'div', className, ...props }, ref) => (
  <TagName aria-hidden="true" {...props} className={cx(skeletonCss, className)} ref={ref} />
)

export default forwardRef(Base)
